import React, { useEffect, useState } from 'react'
import RepresentMoney from '../../utility/represent-money'
import {
  buyerServiceFeeLabel,
  calculateBuyerPrice,
  isBuyerServiceFeeActive,
  loadResalePricingRules
} from '../../utility/resale-pricing'

const FeeInclusivePrice = ({
  sum,
  eurSuffix = false,
  className = '',
  showNote = false,
  noteClassName = '',
  pricingAsOf = null
}) => {
  const [rules, setRules] = useState(null)

  useEffect(() => {
    let mounted = true

    loadResalePricingRules(pricingAsOf).then((nextRules) => {
      if (mounted) {
        setRules(nextRules)
      }
    })

    return () => {
      mounted = false
    }
  }, [pricingAsOf])

  const displaySum = calculateBuyerPrice(sum, rules)

  return (
    <React.Fragment>
      <span className={className}>
        <RepresentMoney sum={displaySum} eurSuffix={eurSuffix} />
      </span>
      {showNote && isBuyerServiceFeeActive(rules) && (
        <div className={noteClassName || 'small'}>
          {buyerServiceFeeLabel(rules)}
        </div>
      )}
    </React.Fragment>
  )
}

export default FeeInclusivePrice
